// extracted by mini-css-extract-plugin
module.exports = {"container":"excerpt_related-module__container--xU_fI"};